import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import { LanguageToggle } from "@/components/LanguageToggle";

const LINKS = [
  { href: "/platform", label: "Platform" },
  { href: "/social-suite", label: "Social Suite" },
  { href: "/coverage", label: "Coverage" },
  { href: "/journalists", label: "For Journalists" },
  { href: "/pricing", label: "Pricing" },
  { href: "/faq", label: "FAQ" },
];

export function MarketingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled
          ? "bg-background/80 backdrop-blur-xl border-b border-border/60 py-2"
          : "bg-transparent py-3"
      }`}
    >
      <div className="container mx-auto px-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center transition-transform hover:-translate-y-0.5">
          <img
            src="/conorbit-logo-transparent.png"
            alt="CONORBIT"
            className={`w-auto transition-all ${scrolled ? "h-10" : "h-14 md:h-16"}`}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 text-sm">
          {LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className={`story-link whitespace-nowrap ${
                location.pathname === l.href ? "text-foreground" : "text-foreground/75 hover:text-foreground"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden lg:flex items-center gap-1">
            <LanguageToggle />
            <ThemeToggle />
          </div>
          <Link to="/auth" className="hidden lg:inline-flex">
            <Button variant="ghost" size="sm">Sign in</Button>
          </Link>
          <Link to="/auth?mode=signup" className="hidden lg:inline-flex">
            <Button size="sm" className="gap-1.5">
              Request access <ArrowRight className="w-3.5 h-3.5" />
            </Button>
          </Link>
          <button className="lg:hidden p-2 text-foreground" onClick={() => setOpen(!open)}>
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden container mx-auto px-4 mt-3 pb-4 border-t border-border/60 pt-4 space-y-3 bg-background/95 backdrop-blur">
          {LINKS.map((l) => (
            <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className="block text-sm text-foreground/80">
              {l.label}
            </Link>
          ))}
          <div className="flex gap-2 pt-2">
            <Link to="/auth" className="flex-1"><Button variant="outline" className="w-full">Sign in</Button></Link>
            <Link to="/auth?mode=signup" className="flex-1"><Button className="w-full">Request access</Button></Link>
          </div>
        </div>
      )}
    </header>
  );
}
